<template>
    <div v-if="chatUserLoaded() && conversationsLoaded && talkjsLoaded">
        <div
            v-b-tooltip.hover.left
            :title="$t('shared.chat.schoolSpecificChats')"
            class="btn-secondary btn clickable add-btn"
            style="background-color:white!important;"
            @click="toggleNewChat"
        >
            <div class="logo-wrapper d-flex align-items-center justify-content-center">
                <img
                    v-if="schoolData.logo && true"
                    class="uni-logo"
                    :src="schoolData.logo"
                    :alt="schoolData.subDomain"
                />
                <BaseIcon v-else name="graduation-cap" size="2x" />
            </div>
        </div>
        <ActiveChats
            v-if="conversationsLoaded"
            :conversations="conversations"
            :unreads="unreads"
            @active-conversation="onActiveConversationChange"
            @remove-conversation="onConversationRemove"
        />
        <Inbox
            v-if="activeConversation !== null"
            :conversation-id="activeConversation ? activeConversation.id : null"
            :active-conversation="activeConversation"
            :session="session"
            @minimize="() => onActiveConversationChange(null)"
            @close="onConversationRemove"
        />
        <NewChat
            v-if="!schoolData.loading && showNewChat"
            :school-id="schoolData.id"
            @close="closeNewChat"
        />
    </div>
</template>

<script>
import ActiveChats from './ActiveChats/ActiveChats';
import Inbox from './Inbox';
import Talk from 'talkjs';
import NewChat from './NewChat';
import UniversityService from '~/services/UniversityService';
import MessageService from '~/services/MessageService';
import DialogService from '~/services/DialogService';

export default {
    name: 'Chat',
    components: { NewChat, Inbox, ActiveChats },
    data() {
        return {
            activeConversation: null,
            unreads: {},
            session: {},
            talkjsLoaded: false,
            conversations: [],
            allConversations: [],
            conversationsLastUnread: {},
            conversationsLoaded: false,
            schoolData: { loading: true },
            showNewChat: false,
        };
    },
    computed: {
        chatUser() {
            return this.$interfaces.communication.chat.user.me.get({
                reactive: true,
            });
        },
    },
    methods: {
        chatUserLoaded() {
            return !this.chatUser.loading;
        },
        onActiveConversationChange(value) {
            if (value) {
                this.closeNewChat();
                if (this.activeConversation) this.conversations.unshift(this.activeConversation);
                if (this.conversations.filter(item => item.id === value).length > 0) {
                    const currentIndex = this.conversations.findIndex(item => item.id === value);
                    this.activeConversation = this.conversations[currentIndex];
                    this.conversations.splice(currentIndex, 1);
                }
            } else {
                if (this.activeConversation) {
                    this.conversations.unshift(this.activeConversation);
                }
                this.activeConversation = value;
            }
        },
        onConversationRemove(conversationId) {
            if (conversationId) {
                if (this.conversations.filter(item => item.id === conversationId).length > 0) {
                    const currentIndex = this.conversations.findIndex(
                        item => item.id === conversationId
                    );
                    this.conversations.splice(currentIndex, 1);
                } else if (this.activeConversation.id === conversationId) {
                    this.activeConversation = null;
                }
                this.$interfaces.communication.chat.conversation.id(conversationId).put({
                    body: {
                        open: false,
                    },
                });
                const allIndex = this.allConversations.findIndex(
                    item => item.id === conversationId
                );
                if (allIndex >= 0) {
                    this.allConversations[allIndex].open = false;
                }
            }
        },
        putConversationFirst(conversationId) {
            if (this.conversations.filter(item => item.id === conversationId).length > 0) {
                const currentIndex = this.conversations.findIndex(
                    item => item.id === conversationId
                );
                if (currentIndex > 0) {
                    const item = this.conversations[currentIndex];
                    this.conversations.splice(currentIndex, 1);
                    this.conversations.unshift(item);
                }
            }
        },
        toggleNewChat() {
            if (this.showNewChat) {
                this.showNewChat = false;
            } else {
                this.showNewChat = true;
                this.onActiveConversationChange(null);
            }
        },
        closeNewChat() {
            this.showNewChat = false;
        },
        getExistingConversationData(chatUserId, convId = null) {
            let res = null;
            let conversations = this.allConversations.filter(conv => {
                if (conv) {
                    let filteredParticipants = conv.participants.filter(participant => {
                        return participant.id === chatUserId;
                    });
                    return !!(filteredParticipants && filteredParticipants.length);
                }
            });
            if (convId) {
                conversations = this.allConversations.filter(conv => conv.id === convId);
            }
            if (conversations && conversations.length) {
                res = conversations[0];
            }
            return res;
        },
    },
    mounted() {
        this.$interfaces.communication.chat.user.me.get().then(resOuter => {
            this.$interfaces.communication.chat.conversation
                .get({ includeClosed: true })
                .then(res => {
                    this.allConversations = res.data;
                    this.conversations = res.data.filter(item => item.open);
                    this.conversationsLoaded = true;
                    Talk.ready.then(() => {
                        let u = new Talk.User(resOuter.data.id);
                        this.session = new Talk.Session({
                            appId: process.env.VUE_APP_TALKJS_APPID,
                            me: u,
                            signature: resOuter.data.signature,
                        });
                        this.talkjsLoaded = true;

                        this.session.unreads.on('change', e => {
                            if (e && e.length) {
                                for (let i = 0; i < e.length; i++) {
                                    if (!e[i].lastMessage.sender) continue;
                                    let id = e[i].lastMessage.conversation.id;
                                    let ts = e[i].lastMessage.timestamp;
                                    if (this.conversationsLastUnread[id] !== ts) {
                                        this.conversationsLastUnread[id] = ts;
                                        this.putConversationFirst(id);
                                    }

                                    let match =
                                        this.activeConversation &&
                                        id === this.activeConversation.id;
                                    for (let j = 0; j < this.conversations.length; j++) {
                                        if (
                                            e[i].lastMessage.conversation.id ===
                                            this.conversations[j].id
                                        ) {
                                            match = true;
                                        }
                                    }
                                    if (!match) {
                                        this.$root.$emit(
                                            'chat-conversation-create-update',
                                            e[i].lastMessage.sender.id,
                                            false,
                                            e[i].lastMessage.conversation.id
                                        );
                                    }
                                }
                            }
                            this.unreads = e;
                        });

                        // Video Chat logic

                        if (localStorage.getItem('wb_current_video_chat')) {
                            DialogService.openVideoChatDialogInvitation({
                                videoChatAction: 're-invited',
                                videoChatID: localStorage.getItem('wb_current_video_chat'),
                            });
                        }
                        this.session.on('message', message => {
                            if (message) {
                                if (
                                    message.custom &&
                                    message.custom &&
                                    message.custom.videoChatAction &&
                                    message.custom.videoChatAction === 'invited'
                                ) {
                                    let filtered = this.allConversations.filter(
                                        item => item.id === message.conversation.id
                                    );
                                    let conversation = filtered[0] || {};
                                    let participants = conversation.participants || [];
                                    let participant = participants[0];
                                    let participantName = participant.displayName || 'Unknown';
                                    let participantAvatar = participant.avatar || null;

                                    let dataObject = {
                                        ...message.custom,
                                        fromName: participantName,
                                        fromAvatar: participantAvatar,
                                    };
                                    if (localStorage.getItem('wb_current_video_chat')) {
                                        this.$root.$emit('video-chat-new-invite', dataObject);
                                        this.$root.$emit(
                                            'video-chat-new-invite-invitation',
                                            dataObject
                                        );
                                    } else {
                                        DialogService.openVideoChatDialogInvitation(dataObject);
                                    }
                                }
                            }
                        });
                    });
                });
        });

        // Can be called from any component. Used to start a new chat, will handle existing closed/open chat and new.
        this.$root.$on(
            'chat-conversation-create-update',
            (participantId, open = true, convId = null) => {
                if (!this.conversationsLoaded) {
                    MessageService.error(
                        'Chat error',
                        'Unable to create chat, conversations not loaded'
                    );
                    return;
                }
                let convData = this.getExistingConversationData(participantId);
                if (convId) {
                    convData = this.getExistingConversationData(participantId, convId);
                    if (!convData) {
                        console.log(
                            'DevError: Received an unread chat to an unknown conversation. Refresh the site.'
                        );
                        return;
                    }
                }
                if (convData) {
                    if (convData.open) {
                        open && this.onActiveConversationChange(convData.id);
                    } else {
                        convData.open = true;
                        this.$interfaces.communication.chat.conversation.id(convData.id).put({
                            body: {
                                open: true,
                            },
                        });
                        this.conversations.push(convData);
                        open && this.onActiveConversationChange(convData.id);
                    }
                } else {
                    this.$interfaces.communication.chat.conversation
                        .post({
                            body: {
                                participants: [participantId],
                            },
                        })
                        .then(res => {
                            this.conversations.push(res);
                            this.allConversations.push(res);
                            open && this.onActiveConversationChange(res.id);
                        })
                        .catch(err => {
                            if (err.response && err.response.status === 400) {
                                if (
                                    err.response.data &&
                                    err.response.data.length &&
                                    err.response.data[0].description
                                ) {
                                    MessageService.error(
                                        'Chat error',
                                        err.response.data[0].description
                                    );
                                }
                            }
                            if (err.response && err.response.status >= 500) {
                                MessageService.error(
                                    'Chat error',
                                    'An unknown error occurred. Try again later or contact support.'
                                );
                            }
                        });
                }
            }
        );
        UniversityService.getCurrentSchoolData().then(data => {
            this.schoolData = data;
        });
    },
};
</script>

<style scoped>
.add-btn {
    height: 60px;
    width: 60px;
    border-radius: 50%;
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.06), 0 2px 3px rgba(0, 0, 0, 0.11);
    position: fixed;
    right: 20px;
    bottom: 85px;
    background-color: transparent !important;
    border-color: rgb(63, 81, 181) !important;
}
.add-btn:hover {
    background-color: rgba(0, 0, 0, 0.1);
}
.logo-wrapper {
    width: 100%;
    height: 100%;
    max-width: 100%;
    max-height: 100%;
    overflow: hidden;
}
.uni-logo {
    height: 100%;
    width: 100%;
    object-fit: scale-down;
}
</style>
